import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Result, Button, Typography, Alert } from "antd";
import _ from "lodash";
const { Paragraph, Text } = Typography;

function ErrorFallback() {
  const location = useLocation();
  const navigate = useNavigate();

  const { state: { message = "", data = {}, from = {} } = {} } = location;

  const handleBack = () => {
    navigate(`${from.pathname}${from.search}` || `/home/v2${from.search}`, {
      state: { from: location },
    });
  };

  return (
    <React.Fragment>
      <Result
        status="warning"
        title={message || "Something Went Wrong!"}
        subTitle="Please check the following information."
        extra={
          <Button type="primary" onClick={handleBack}>
            Try Again
          </Button>
        }
      />
      <Paragraph>
        <Text strong style={{ fontSize: 16 }}>
          Errors:
        </Text>
      </Paragraph>
      {typeof data !== "object" ? (
        <Alert
          showIcon
          type="warning"
          style={{ margin: ".5%" }}
          message={JSON.stringify(data)}
        />
      ) : (
        _.map(data, (value, key) =>
          typeof value !== "object" ? (
            <Alert
              showIcon
              type="warning"
              style={{ margin: ".5%" }}
              key={key}
              message={`${JSON.stringify(key)}: ${JSON.stringify(value)}`}
            />
          ) : (
            _.map(value, (_value, _key) => (
              <Alert
                showIcon
                type="warning"
                style={{ margin: ".5%" }}
                key={_key}
                message={`${JSON.stringify(_key)}: ${JSON.stringify(_value)}`}
              />
            ))
          ),
        )
      )}
    </React.Fragment>
  );
}

export default ErrorFallback;
